import { asCorporateBondId, asTradeTicketId, Currency, OrderDirection } from "@goodfill/domain-properties";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { pricedBondState, userDataState } from "../../../../state";
import { PageLayoutFixed } from "../../../layouts/PageLayoutFixed";
import { BondNotFound } from "../../BondNotFound";
import { CreateOrderContainer } from "./CreateOrderContainer";

function _CreateOrder() {
  const pricedBond = useRecoilValue(pricedBondState);
  const userData = useRecoilValue(userDataState);

  const { bondId, orderDirection: orderDirectionParam, tradeTicketId: tradeTicketIdParam } = useParams();

  const tradeDate = useMemo<DateTime>(() => DateTime.local(), []);
  const orderDirection = orderDirectionParam === "buy" ? OrderDirection.Buy : OrderDirection.Sell;
  const tradeTicketId = tradeTicketIdParam ? asTradeTicketId(tradeTicketIdParam) : null;
  const selectedBondItem = bondId ? pricedBond.get(asCorporateBondId(bondId)) : undefined;

  if (!orderDirection) {
    return <>ERROR: Invalid order direction: {orderDirectionParam}</>;
  }

  if (selectedBondItem === undefined) {
    return <BondNotFound bondId={bondId} />;
  }

  if (userData == null) {
    return <>ERROR: User not logged</>;
  }

  const balanceAccount = userData.getBalanceAccount(Currency.USD);

  if (balanceAccount === null) {
    return <>ERROR: BalanceAccount not loaded</>;
  }

  return (
    <CreateOrderContainer
      pricedBond={selectedBondItem}
      accountId={userData.account.id}
      moneyBalanceAccount={balanceAccount}
      tradeDate={tradeDate}
      orderDirection={orderDirection}
      tradeTicketId={tradeTicketId}
    />
  );
}

export const CreateOrderScreen = () => {
  return (
    <PageLayoutFixed>
      <_CreateOrder />
    </PageLayoutFixed>
  );
};
